import { render, staticRenderFns } from "./FIGUREITOUT.vue?vue&type=template&id=2a076a50&"
import script from "./FIGUREITOUT.vue?vue&type=script&lang=js&"
export * from "./FIGUREITOUT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports